const o = {
  name: "Mauritius",
  dimensions: { width: 20, height: 21 },
  content: `
    <g>
      <path d="M9.99512 5.58752C11.0997 5.58752 11.9951 4.69209 11.9951 3.58752C11.9951 2.48295 11.0997 1.58752 9.99512 1.58752C8.89055 1.58752 7.99512 2.48295 7.99512 3.58752C7.99512 4.69209 8.89055 5.58752 9.99512 5.58752Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.99512 5.58752V18.5875" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18.0651 14.5875C16.5951 17.5475 13.5351 19.5875 10.0051 19.5875C6.46506 19.5875 3.40506 17.5475 1.93506 14.5875" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.99512 8.58752H14.9951" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  o as Mauritius
};
